// Import custom components
import Home from "../views/home";
import Login from "../views/login";
import Layout from "../views/layout";
import NotFound from "../views/common/not_found";
import CustomerDetails from "../views/customers/details";
import Customers from "../views/customers";
import Migration from "../views/migration";
import CreateMigration from "../views/migration/create-migration"
import MigrationStatus from "../views/migration/create-migration/components/migration_status_template"
import CreateCustomer from "../views/customers/create-customer";
import Coworkers from "../views/coworkers";
import CoWorkerDetails from "../views/coworkers/details";
import Settings from "../views/settings/";
import { ADMIN, CS, SUPERADMIN } from "../constants/roles";

const routingObject = [
  {
    element: <Layout />,
    name: "",
    icon: "",
    errorElement: <Layout />,
    layout: "admin",
    children: [
      {
        path: "/",
        role: ["*"],
        element: <Home />,
      },
      {
        path: "/customers",
        role: ["*"],
        element: <Customers />,
        isPrivate: true,
      },
      {
        path: "/migration",
        role: ["*"],
        element: <Migration />,
        isPrivate: true,
      },
      {
        path: "/migration/create",
        role: [SUPERADMIN, ADMIN],
        element: <CreateMigration />,
        isPrivate: true,
      },
      {
        path: "/migration/:migration_uid/:currentModule",
        role: [SUPERADMIN, ADMIN],
        element: <CreateMigration />,
        isPrivate: true,
      },
      {
        path: "/customers/create",
        role: [SUPERADMIN, ADMIN],
        element: <CreateCustomer />,
        isPrivate: true,
      },
      {
        path: "/customers/:company_uid",
        role: ["*"],
        children: [
          {
            path: ":type",
            element: <CustomerDetails />,
          }
        ],
        isPrivate: true,
      },
      {
        path: "/coworkers",
        role: [ADMIN, SUPERADMIN],
        element: <Coworkers />,
        isPrivate: true,
      },
      {
        path: "/coworkers/:coworker_uid",
        role: [ADMIN, SUPERADMIN],
        children: [
          {
            path: ":type",
            element: <CoWorkerDetails />,
          }
        ],
        isPrivate: true,
      },
      {
        path: "/home",
        role: ["*"],
        element: <Home />,
        isPrivate: true,
      },
      {
        path: "/settings",
        role: ["*"],
        element: <Settings />,
        isPrivate: true,
      },
    ],
  },
  {
    element: <Login />,
    path: "/login",
    role: ["*"],
  },
  {
    element: <NotFound />,
    path: "*",
    role: ["*"],
  },
];

export default routingObject;
